var map = {
	"./cov_ashtami.jpg": 1938,
	"./cov_dandiya.jpg": 1090,
	"./cov_dashami.jpg": 642,
	"./cov_full_event.jpg": 2666,
	"./cov_nabami.jpg": 206,
	"./cov_panchami.jpg": 9896,
	"./cov_saptami.jpg": 1484,
	"./cov_shashthi.jpg": 6322,
	"./cov_weekend.jpg": 2796
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6933;